import { createSlice } from "@reduxjs/toolkit";

interface AddCreditDrawerState {
  isActive: boolean;
  addDependent: boolean;
  isChanged: boolean;
  reloadEmployer: boolean;
  employerCounts: {
    employeeCount: number;
    dependentCount: number;
    totalCount: number;
  };
}

const initialState: AddCreditDrawerState = {
  isActive: false,
  addDependent: false,
  isChanged: false,
  reloadEmployer: false,
  employerCounts: {
    employeeCount: 0,
    dependentCount: 0,
    totalCount: 0,
  },
};

const employerSlice = createSlice({
  name: "employer",
  initialState,
  reducers: {
    setIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    setAddDependent: (state, action) => {
      state.addDependent = action.payload;
    },
    setIsChanged: (state, action) => {
      state.isChanged = action.payload;
    },
    setReloadEmployer: (state, action) => {
      state.reloadEmployer = action.payload;
    },
    setEmployerCounts: (state, action) => {
      state.employerCounts = action.payload;
    },
  },
});

export const {
  setIsActive,
  setAddDependent,
  setIsChanged,
  setReloadEmployer,
  setEmployerCounts,
} = employerSlice.actions;

export default employerSlice.reducer;
